import React, { Component } from 'react';
import {
  Alert,
  Button,
  Carousel,
  Col,
  Grid,
  OverlayTrigger,
  Row,
  Popover,
  Modal
} from 'react-bootstrap';
import {Analytics, API} from "aws-amplify";
import ReactGA from 'react-ga';
import {Link} from "react-router-dom";
import moment from "moment";
import SocialShare from "../components/Marketing/SocialShare";
import {LinkContainer} from "react-router-bootstrap";
import HireJasper from "../components/Marketing/HireJasper";
import GoogleAd from "../components/Marketing/GoogleAd";
import ExamList from "../components/Exam/ExamList";
import BlogList from "../components/Blog/BlogList";
import TagsList from "../components/Blog/TagsList";
function waitForFBInit() {
  return new Promise((res, rej) => {
    const hasFbLoaded = () => {
      if (window.FB) {
        window.FB.XFBML.parse();
        res();
      } else {
        setTimeout(hasFbLoaded, 300);
      }
    };
    hasFbLoaded();
  });
}

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAlert: true,
      showModal: false,
      certificationModal: false,
      modalMessage: '',
      loadingCertifications: true,
      newestCertifications: [],
      blogsLoading: true,
      blogList: []
    };
  }

  async componentDidMount(){
    document.title = process.env.REACT_APP_COMPANY_NAME+" | Homepage";
    ReactGA.initialize('UA-134679120-1');
    ReactGA.pageview('/homepage');
    window.fbq('track', 'ViewContent');
    try {
      // Get Newest Certifications
      const newest = await API.get("api", "/certification/newest");
      let newestCertifications = [];
      // Map through the newest certifications and get the profile info for each certification
      await Promise.all(newest.map(async (certification) => {
        const user = await API.get("api", `/profile/${certification.userId}`);
        certification.userName = user.userName;
        certification.userId = user.displayedURL ? user.displayedURL : user.userId;
        certification.length = user.certifications.length;
        if (user.hasOwnProperty('socialMedia')) {certification.socialMedia = user.socialMedia;}
        if (user.hasOwnProperty('userLocation')) {certification.userLocation = user.userLocation;}
        certification.createdAt = user.createdAt;
        newestCertifications.push(certification);
      }));
      newestCertifications.sort((a,b) => (a.issued < b.issued) ? 1 : ((b.issued < a.issued) ? -1 : 0));
      this.setState({newestCertifications});

      await this.newestBlogPosts();

    } catch (e) {
      let errorMessage = 'There was a problem loading the newest certifications.';
      if (e.response) {errorMessage = e.response.data.message;}
      this.setState({
        modalMessage: errorMessage,
        showModal: true
      });
    } finally {
      this.setState({loadingCertifications: false});
    }
    await waitForFBInit();
  }
  
  newestCertifications() {
    return this.state.newestCertifications.map((certification, index) => {

      // load an ad in the middle of the certification list

      /*<div style={{marginLeft:14, marginTop:10}}>
        <small style={{color: '#999999', fontStyle: 'italic'}}>advertisement</small>
      </div>
      <div>
        <iframe
          title="Amazon Large Banner"
          style={{marginLeft:15}} marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0"
          src="//rcm-na.amazon-adsystem.com/e/cm?o=1&p=49&l=ur1&category=amazonhomepage&f=ifr&linkID=30b26e805d3f4ecee793d7ecf0614a51&t=jasperthaye03-20&tracking_id=jasperthaye03-20"
          width="300"
          height="600"
        >
        </iframe>
      </div>*/

      return (
        <div style={{marginTop:'-1px'}} className='certification valid-certification' key={certification.validationNumber}>
          <div>
            <OverlayTrigger
              placement="top"
              delayShow={300}
              delayHide={150}
              overlay={<Popover id={certification.validationNumber}>
                View <b>{certification.userName}</b>'s {process.env.REACT_APP_COMPANY_NAME} profile.
              </Popover>}>
              <Link style={{fontWeight:'bold'}} to={`/${certification.userId}`}>{certification.userName} {certification.length === 14 && <i style={{color:'#FFD700', textShadow: '0 0 1px #000'}} className="fa fa-star fa-fw" aria-hidden="true"/>}</Link>
            </OverlayTrigger>
          </div>

          {certification.userLocation && <div style={{marginBottom:3, fontSize:9}}>
            <i className="fa fa-map-marker fa-fw" aria-hidden="true"/>
            {certification.userLocation.city && certification.userLocation.userRegion && <span>{certification.userLocation.city}, {certification.userLocation.userRegion}</span>}
            {certification.userLocation.city && !certification.userLocation.userRegion && <span>{certification.userLocation.city}</span>}
            {!certification.userLocation.city && certification.userLocation.userRegion && <span>{certification.userLocation.userRegion}</span>}
            {certification.userLocation.country && <span> {certification.userLocation.country}</span>}
          </div>}

          {certification.socialMedia && <div>
            {/* LinkedIn */}
            {certification.socialMedia.linkedin && <OverlayTrigger
              placement="top"
              delayShow={300}
              delayHide={150}
              overlay={<Popover id="popoverLinkedIn">
                Connect with <b>{certification.userName}</b> on LinkedIn.
              </Popover>}>
              <a
                style={{paddingRight:5}}
                href={`https://linkedin.com/in/${certification.socialMedia.linkedin}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button bsStyle="default" bsSize="xsmall">
                  <i className="fa fa-linkedin fa-fw" aria-hidden="true"/>
                </Button>
              </a>
            </OverlayTrigger>}

            {/* GitHub */}
            {certification.socialMedia.github && <OverlayTrigger
              placement="top"
              delayShow={300}
              delayHide={150}
              overlay={<Popover id="popoverGitHub">
                Fork <b>{certification.userName}</b> on GitHub.
              </Popover>}>
              <a
                style={{paddingRight:5}}
                href={`https://github.com/${certification.socialMedia.github}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button bsStyle="default" bsSize="xsmall">
                  <i className="fa fa-github fa-fw" aria-hidden="true"/>
                </Button>
              </a>
            </OverlayTrigger>}

            {/* Facebook */}
            {certification.socialMedia.facebook && <OverlayTrigger
              placement="top"
              delayShow={300}
              delayHide={150}
              overlay={<Popover id="popoverFacebook">
                Connect with <b>{certification.userName}</b> on Facebook.
              </Popover>}>
              <a
                style={{paddingRight:5}}
                href={`https://facebook.com/${certification.socialMedia.facebook}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button bsStyle="default" bsSize="xsmall">
                  <i className="fa fa-facebook fa-fw" aria-hidden="true"/>
                </Button>
              </a>
            </OverlayTrigger>}

            {/* Twitter */}
            {certification.socialMedia.twitter && <OverlayTrigger
              placement="top"
              delayShow={300}
              delayHide={150}
              overlay={<Popover id="popoverTwitter">
                Follow <b>@{certification.socialMedia.twitter}</b> on Twitter.
              </Popover>}>
              <a
                style={{paddingRight:5}}
                href={`https://twitter.com/${certification.socialMedia.twitter}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button bsStyle="default" bsSize="xsmall">
                  <i className="fa fa-twitter fa-fw" aria-hidden="true"/>
                </Button>
              </a>
            </OverlayTrigger>}

            {/* Website */}
            {certification.socialMedia.website && <OverlayTrigger
              placement="top"
              delayShow={300}
              delayHide={150}
              overlay={<Popover id="popoverURL">
                Visit <b>{certification.socialMedia.website}</b>
              </Popover>}>
              <a
                href={certification.socialMedia.website}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button bsStyle="default" bsSize="xsmall">
                  <i className="fa fa-desktop fa-fw" aria-hidden="true"/>
                </Button>
              </a>
            </OverlayTrigger>}
          </div>}

          <div>
            <OverlayTrigger
              placement="top"
              delayShow={300}
              delayHide={150}
              overlay={<Popover id={certification.validationNumber}>
                View the official validation for this <b>{certification.title}</b> certification.
              </Popover>}>
              <a
                href={'https://aw.certmetrics.com/amazon/public/verification.aspx?code='+certification.validationNumber}
                rel="noopener noreferrer"
                target="_blank"
              >
                <i style={{color: '#5cb85c', marginRight: 5}} className='fa fa-check fa-fw' aria-hidden='true'/>
              </a>
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              delayShow={300}
              delayHide={150}
              overlay={
                <Popover id={certification.fileName}>
                  View this <b>{certification.title}</b> certification.
                </Popover>}>
              <a
                href={`https://${process.env.REACT_APP_DOMAIN_NAME}`}
                onClick={(e) => this.viewCertification(e, certification.fileName)}
              >
                {certification.title}
              </a>
            </OverlayTrigger>
          </div>

          <div style={{marginTop:0, marginBottom:5, fontSize:9}}>
            <b>Issued:</b> <span> {moment(certification.issued*1000).toNow(true)} ago
          </span>
          </div>
        </div>
      );


    });
  }

  async newestBlogPosts() {
    this.setState({blogsLoading: true});
    try {
      const blogList = await API.get("api", `/blog/list/home`);
      let returnState = {};
      if (blogList.hasOwnProperty('blogPosts')) returnState.blogList = blogList.blogPosts;
      if (blogList.blogTags) returnState.blogTags = blogList.blogTags;
      this.setState(returnState);
    } catch(e) {
      let errorMessage = 'There aren\'t any blogs available.';
      if (e.message && e.message !== 'Network Error') {errorMessage = e.message;}
      if (e.response && e.response !== 'Network Error') {errorMessage = e.response.data.errorMessage;}
      this.setState({
        bsClass: 'modal-header modal-header-danger',
        modalTitle: 'Error',
        modalMessage: errorMessage,
        showModal: true
      });
    } finally {
      this.setState({
        blogsLoading: false
      });
    }
  }

  fbLGPageBlock() {
    return (
      <div
        className="fb-page"
        data-href={`https://www.facebook.com/${process.env.REACT_APP_DOMAIN_NAME}`}
        data-tabs="timeline"
        data-small-header="true"
        data-adapt-container-width="true"
        data-hide-cover="false"
        data-width="500"
        data-height="800"
        data-show-facepile="true"
        data-hide-cta="true"
        style={{marginTop:10}}
      >
        <blockquote cite={`https://www.facebook.com/${process.env.REACT_APP_DOMAIN_NAME}`} className="fb-xfbml-parse-ignore">
          <a href={`https://www.facebook.com/${process.env.REACT_APP_DOMAIN_NAME}`}>{process.env.REACT_APP_DOMAIN_NAME}</a>
        </blockquote>
      </div>
    );
  }

  fbMDPageBlock() {
    return (
      <div
        className="fb-page"
        data-href={`https://www.facebook.com/${process.env.REACT_APP_DOMAIN_NAME}`}
        data-tabs="timeline"
        data-small-header="true"
        data-adapt-container-width="true"
        data-hide-cover="false"
        data-width="500"
        data-height="800"
        data-show-facepile="true"
        data-hide-cta="true"
        style={{marginTop:10}}
      >
        <blockquote cite={`https://www.facebook.com/${process.env.REACT_APP_DOMAIN_NAME}`} className="fb-xfbml-parse-ignore">
          <a href={`https://www.facebook.com/${process.env.REACT_APP_DOMAIN_NAME}`}>{process.env.REACT_APP_DOMAIN_NAME}y</a>
        </blockquote>
      </div>
    );
  }

  alertMessage() {
    return (
      <Alert style={{position:"relative", marginTop:20, marginBottom:0}} bsStyle="success">
        <h4><b>Help spread the word about the {process.env.REACT_APP_COMPANY_NAME}!</b></h4>
        <p>Share the {process.env.REACT_APP_COMPANY_NAME} with friends, connections, and coworkers to help spread the word.</p>
        <SocialShare
          style={{marginTop:10}}
          size="xs"
          url={`https://${process.env.REACT_APP_DOMAIN_NAME}/directory`}
          title={`View AWS certified users from around the world on the ${process.env.REACT_APP_COMPANY_NAME}.`}
        />
        <div style={{position:"absolute", top:10, right:10}}>
          <Button onClick={this.alertClose} bsStyle="success">X</Button>
        </div>
      </Alert>
    );
  }
  alertClose = () => {
    Analytics.record('AlertMessageClosed', { page: 'Homepage', message: 'Social Share CTA' });
    this.setState({showAlert: false});
    // write a cookie that expires in a year so the alert isn't showed to the user anymore
    document.cookie = `homepageSocialShareAlert=false;max-age=31536000;path=/`;
  };
  viewCertification = (e, fileName) => {
    e.preventDefault();
    this.setState({
      certificationModal: true,
      modalMessage: fileName
    });
  };
  modalClose = () => {
    this.setState({
      showModal: false,
      certificationModal: false
    });
  };

  render() {
    return (
      <div>
        <HireJasper isAuthenticated={this.props.isAuthenticated}/>
        <Carousel style={{marginTop:50, marginBottom:-50, borderBottom:"solid 1px #444444", boxShadow:"0px 5px 20px rgba(0,0,0,0.7)"}} interval={20000}>
          {/*<Carousel.Item>
            <img width="100%" height="100%" alt={process.env.REACT_APP_COMPANY_NAME} src="tutorials.jpg"/>
            <Carousel.Caption>
              <div className="carouselcaption">
                <h2>AWS Video Tutorials</h2>
                <p>Watch our new <Link style={{fontWeight:'bold', textDecoration:'underline'}} to='/tutorials'>Video Tutorials</Link> to help you learn about AWS!</p>
              </div>
            </Carousel.Caption>
          </Carousel.Item>*/}
          <Carousel.Item>
            <img width="100%" height="100%" alt={process.env.REACT_APP_COMPANY_NAME} src="blog.jpg"/>
            <Carousel.Caption>
              <div className="carouselcaption">
                <p style={{paddingTop:10}}>Our new <Link style={{fontWeight:'bold', textDecoration:'underline'}} to='/blog'>blog</Link> is live and it's dope AF! Developed entirely serverless.</p>
              </div>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img width="100%" height="100%" alt={process.env.REACT_APP_COMPANY_NAME} src="exams.jpg"/>
            <Carousel.Caption>
              <div className="carouselcaption">
                <h2>AWS Practice Exams</h2>
                <p>Our new <Link style={{fontWeight:'bold', textDecoration:'underline'}} to='/exams'>AWS Certification Practice Exams</Link> are now available!</p>
              </div>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img width="100%" height="100%" alt={process.env.REACT_APP_COMPANY_NAME} src="directory.jpg"/>
            <Carousel.Caption>
              <div className="carouselcaption">
                <h2>{process.env.REACT_APP_COMPANY_NAME}</h2>
                <p>View locations of AWS Certified individuals from around the world!</p>
              </div>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img width="100%" height="100%" alt={process.env.REACT_APP_COMPANY_NAME} src="hollywood.jpg"/>
            <Carousel.Caption>
              <div className="carouselcaption">
                <h2>Made In America</h2>
                <p>Built and maintained in beautiful, sunny California</p>
              </div>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img width="100%" height="100%" alt={process.env.REACT_APP_COMPANY_NAME} src="working.jpg"/>
            <Carousel.Caption>
              <div className="carouselcaption">
                <h2>{process.env.REACT_APP_COMPANY_NAME}</h2>
                <p>Showcase your credentials and verify to the world you're AWSome!</p>
              </div>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img width="100%" height="100%" alt={process.env.REACT_APP_COMPANY_NAME} src="serverless.jpg" />
            <Carousel.Caption>
              <div className="carouselcaption">
                <h2>100% Serverless Directory</h2>
                <p>Developed using API Gateway, Lambda, DynamoDB, and Amplify</p>
              </div>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>

        <Grid className="page">

          {/*<Row style={{marginTop:20}}>
            <Col xs={12}>
              <GoogleAd/>
            </Col>
          </Row>*/}

          <Row style={{marginTop:17}}>
            <Col xs={12}>
              <div
                style={{
                  position:'absolute',
                  bottom:0,
                  right:15,
                  paddingLeft:5,
                  paddingRight:5,
                  marginLeft:15,
                  border:'solid 1px #000000',
                  backgroundColor:'#FFFFFF',
                  fontSize:'2.3vw'
                }}>
                AWS Certified Advanced Networking Official Study Guide
              </div>
              <a href="https://amzn.to/3nw2w0P">
                <OverlayTrigger
                  placement="top"
                  delayShow={300}
                  delayHide={150}
                  overlay={<Popover id="popoverNetworkStudyGuide">
                    A must-have resource if you're serious about passing the Advanced Networking Specialty Exam
                  </Popover>}>
                    <img width="100%" height="100%" alt={process.env.REACT_APP_COMPANY_NAME} src="aws-certified-advanced-networking-ad.jpg"/>
                </OverlayTrigger>
              </a>
            </Col>
          </Row>

          <Row className="show-grid">

            {this.state.showAlert && !document.cookie.includes("homepageSocialShareAlert=false") && <Col xs={12}>
              {this.alertMessage()}
            </Col>}

            <Col xs={12} md={7} lg={8}>
              {!this.state.blogsLoading && <h2 style={{marginTop:10, fontWeight:'bold'}}>Newest Blogs:</h2>}
              {!this.state.blogsLoading && <BlogList
                history={this.props.history}
                blogList={this.state.blogList}
              />}
              <h2 style={{display:'inline-block', marginTop:10, fontWeight:'bold'}}>AWS Practice Exams:</h2>
              <ExamList history={this.props.history} />
            </Col>

            <Col xsHidden smHidden mdHidden lg={4} style={{paddingLeft:0}}>

              <Col xs={12} style={{marginTop:50, marginBottom:10, padding:0}}>
                <TagsList />
              </Col>

              <Col sm={12} style={{padding:0}}>
                <LinkContainer to='/profile' style={{color:'#FFFFFF', marginBottom:10}}>
                  <Button bsStyle="success" block><i className="fa fa-plus fa-fw" aria-hidden="true"/> Add Your AWS Certification</Button>
                </LinkContainer>
                {!this.state.loadingCertifications && <h4 style={{marginTop:0, fontWeight:'bold'}}>Newest Certifications:</h4>}
                {this.state.loadingCertifications && <div className='LoaderButton' style={{fontSize:150, textAlign:'center', marginBottom:-20}}>
                  <i className="fa fa-refresh fa-fw spinning" aria-hidden="true"/>
                </div>}
                {!this.state.loadingCertifications && this.newestCertifications()}

                <div style={{marginTop:10}}>
                  <small style={{color: '#999999', fontStyle: 'italic'}}>advertisement</small>
                </div>
                <div>
                  <iframe
                    style={{width:120, height:240, marginRight:7}} marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0"
                    title="Advanced Networking Official Study Guide"
                    src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ss&ref=as_ss_li_til&ad_type=product_link&tracking_id=jasperthaye03-20&language=en_US&marketplace=amazon&region=US&placement=1119439833&asins=1119439833&linkId=601b4b54c2ac117a5a30a65432e55658&show_border=true&link_opens_in_new_window=true"/>

                  <iframe
                    style={{width:120, height:240, marginRight:7}} marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0"
                    title="Amazon T Shirt"
                    src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ss&ref=as_ss_li_til&ad_type=product_link&tracking_id=jasperthaye03-20&language=en_US&marketplace=amazon&region=US&placement=B07J9RCPV5&asins=B07J9RCPV5&linkId=d23f83c2d53aad8dd6b324b097abf951&show_border=true&link_opens_in_new_window=true"/>

                  <iframe
                    style={{width:120, height:240}} marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0"
                    title="Amazon T Shirt"
                    src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ss&ref=as_ss_li_til&ad_type=product_link&tracking_id=jasperthaye03-20&language=en_US&marketplace=amazon&region=US&placement=B07YVSWC3K&asins=B07YVSWC3K&linkId=af30c357d4111fb06f0c2b8dea5421e6&show_border=true&link_opens_in_new_window=true"/>
                </div>

                {/*{this.fbLGPageBlock()}*/}
              </Col>
            </Col>

            <Col xsHidden smHidden md={5} lgHidden style={{paddingLeft:0}}>

              <Col md={12} style={{padding:0, marginTop:50, marginBottom:10}}>
                <TagsList />
              </Col>

              <Col sm={12} style={{padding:0}}>
                <LinkContainer to='/profile' style={{color:'#FFFFFF', marginBottom:10}}>
                  <Button bsStyle="success" block><i className="fa fa-plus fa-fw" aria-hidden="true"/> Add Your AWS Certification</Button>
                </LinkContainer>
                {this.state.loadingCertifications && <h4 style={{marginTop:0, fontWeight:'bold'}}>Newest Certifications:</h4>}
                {this.state.loadingCertifications && <div className='LoaderButton' style={{fontSize:150, textAlign:'center', marginBottom:-20}}>
                  <i className="fa fa-refresh fa-fw spinning" aria-hidden="true"/>
                </div>}
                {!this.state.loadingCertifications && this.newestCertifications()}

                <div style={{marginTop:10}}>
                  <small style={{color: '#999999', fontStyle: 'italic'}}>advertisement</small>
                </div>
                <div>
                  <iframe
                    style={{width:120, height:240, marginRight:13}} marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0"
                    title="Advanced Networking Official Study Guide"
                    src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ss&ref=as_ss_li_til&ad_type=product_link&tracking_id=jasperthaye03-20&language=en_US&marketplace=amazon&region=US&placement=1119439833&asins=1119439833&linkId=601b4b54c2ac117a5a30a65432e55658&show_border=true&link_opens_in_new_window=true"/>

                  <iframe
                    style={{width:120, height:240, marginRight:13}} marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0"
                    title="Amazon T Shirt"
                    src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ss&ref=as_ss_li_til&ad_type=product_link&tracking_id=jasperthaye03-20&language=en_US&marketplace=amazon&region=US&placement=B07J9RCPV5&asins=B07J9RCPV5&linkId=d23f83c2d53aad8dd6b324b097abf951&show_border=true&link_opens_in_new_window=true"/>

                  <iframe
                    style={{width:120, height:240}} marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0"
                    title="Amazon T Shirt"
                    src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ss&ref=as_ss_li_til&ad_type=product_link&tracking_id=jasperthaye03-20&language=en_US&marketplace=amazon&region=US&placement=B07YVSWC3K&asins=B07YVSWC3K&linkId=af30c357d4111fb06f0c2b8dea5421e6&show_border=true&link_opens_in_new_window=true"/>
                </div>

                {/*{this.fbMDPageBlock()}*/}
              </Col>
            </Col>

            <Col xs={12} mdHidden lgHidden style={{marginTop:20}}>

              <Col xs={12} style={{padding:0, display:'contents'}}>
                <TagsList />
              </Col>

              <Col sm={12} style={{padding:0, marginTop:15}}>
                <LinkContainer to='/profile' style={{color:'#FFFFFF', marginBottom:10}}>
                  <Button bsStyle="success" block><i className="fa fa-plus fa-fw" aria-hidden="true"/> Add Your AWS Certification</Button>
                </LinkContainer>
                {this.state.loadingCertifications && <h4 style={{marginTop:0, fontWeight:'bold'}}>Newest Certifications:</h4>}
                {this.state.loadingCertifications && <div className='LoaderButton' style={{fontSize:150, textAlign:'center', marginBottom:-20}}>
                  <i className="fa fa-refresh fa-fw spinning" aria-hidden="true"/>
                </div>}
                {!this.state.loadingCertifications && this.newestCertifications()}
              </Col>
            </Col>

          </Row>

          <Row style={{marginTop:20}}>
            <Col xs={12}>
              <GoogleAd/>
            </Col>
          </Row>

        </Grid>

        <Modal show={this.state.certificationModal} onHide={this.modalClose} dialogClassName="certification-modal">
          <Modal.Body style={{padding:0}}>
            <img
              width='100%'
              height='100%'
              alt={process.env.REACT_APP_COMPANY_NAME}
              src={`https://s3.amazonaws.com/${process.env.REACT_APP_S3_BUCKET.toLowerCase()}/certifications/${this.state.modalMessage}`}
            />
          </Modal.Body>
        </Modal>

        <Modal show={this.state.showModal} onHide={this.modalClose}>
          <Modal.Header bsClass="modal-header modal-header-danger" closeButton>
            <i className="fa fa-warning fa-fw" aria-hidden="true"/> Error
          </Modal.Header>
          <Modal.Body>
            {this.state.modalMessage}
          </Modal.Body>
        </Modal>

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/Homepage.js